import { useEffect, useState } from 'react'
import { BrowserView, MobileView } from 'react-device-detect'
import '../../styles/Actuality/ActualityDetail.css'
import { useParams } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'
import { Fade, Zoom } from 'react-awesome-reveal'
import axios from 'axios'
import { RotatingLines } from 'react-loader-spinner'
import { Buffer } from 'buffer'

function ActualityDetail() {

    const { id } = useParams()
    const [isLoading, setIsLoading] = useState(true)
    const [actuality, setActuality] = useState(null)

    useEffect(() => {

        window.scrollTo({ top: 0, behavior: 'instant' })
        setIsLoading(true)
        axios.get(process.env.REACT_APP_API_URL + 'actuality/' + id).then((response) => {
            const item = response.data
            item.date = new Date(item.date).toLocaleDateString('fr-FR')
            item.image = process.env.REACT_APP_API_URL + 'actuality/' + item.id + '/image'
            setActuality(item)
            setIsLoading(false)
        }).catch((error) => {
            console.log('error :\n' + JSON.stringify(error) + '\n\n')
            setIsLoading(false)
        })

    }, [id])

    function renderContent(content) {
        if (Buffer.isBuffer(content)) {
            return Buffer.from(content).toString('utf-8')
        }
        if (typeof content === 'object' && content?.type === 'Buffer') {
            return Buffer.from(content.data).toString('utf-8')
        }
        return content
    }

    if (isLoading) {
        return (
            <div className='loader'>
                <RotatingLines
                    strokeColor={'#5b7c18'}
                    strokeWidth={'5'}
                    animationDuration={'1'}
                    width={'40'}
                    visible={true}
                />
            </div>
        )
    }

    if (!actuality) {
        return null
    }

    return (

        <>
            <BrowserView>
                <div id='actualityDetail'>
                    <Fade duration={500}>
                        <div id='actualityDetailTitle'>{actuality.title}</div>
                    </Fade>
                    <Fade>
                        <div id='actualityDetailDate'>
                            <FontAwesomeIcon icon={faCalendar} id='actualityDetailDateIcon' />
                            {actuality.date}
                        </div>
                    </Fade>
                    <Zoom>
                        <img src={actuality.image} className='actualityDetailImage' alt="actualityImage" loading="lazy" />
                    </Zoom>
                    <Fade>
                        <div className='actualityDetailText'>{actuality.text}</div>
                    </Fade>
                    <Fade>
                        <div className='actualityDetailText'
                            dangerouslySetInnerHTML={{
                                __html: renderContent(actuality.content)
                            }}
                        />
                    </Fade>
                </div>
            </BrowserView>

            <MobileView>
                <div id='actualityDetail'>
                    <Fade duration={500}>
                        <div id='actualityDetailTitleMobile'>{actuality.title}</div>
                    </Fade>
                    <Fade>
                        <div id='actualityDetailDate'>
                            <FontAwesomeIcon icon={faCalendar} id='actualityDetailDateIcon' />
                            {actuality.date}
                        </div>
                    </Fade>
                    <Zoom>
                        <img src={actuality.image} className='actualityDetailImageMobile' alt="actualityImage" loading="lazy" />
                    </Zoom>
                    <Fade>
                        <div className='actualityDetailText'>{actuality.text}</div>
                    </Fade>
                    <Fade>
                        <div className='actualityDetailTextMobile'
                            dangerouslySetInnerHTML={{
                                __html: renderContent(actuality.content)
                            }}
                        />
                    </Fade>
                </div>
            </MobileView>
        </>

    )

}

export default ActualityDetail
